/** The 403 code `GET api/user/Me` answers when an enterprise sign-in has no matching security role (UserController). */
export const SSO_NO_MATCHING_ROLE = 'sso-no-matching-role';

/**
 * The API's message when `/Me` refused an enterprise (ADFS / Entra) sign-in because none of the user's
 * AD groups matches a security role in this database, the same refusal the desktop gives; otherwise null.
 */
export function ssoRefusalMessage(err: unknown): string | null {
  const response = (err as { response?: { status?: number; data?: unknown } } | null)?.response;
  if (response?.status !== 403) return null;
  const data = response.data as { code?: unknown; message?: unknown } | null | undefined;
  if (!data || data.code !== SSO_NO_MATCHING_ROLE) return null;
  return typeof data.message === 'string' && data.message.trim()
    ? data.message
    : 'None of your Active Directory groups matches a security role here. Please contact your IT Administrator.';
}
